export default [
  {
    name: 'Yes Or No',
    value: 'yes_or_no'
  },
  {
    name: 'Highly To Unlikely',
    value: 'highly_to_unlikely'
  },
  {
    name: 'Excellent To Poor',
    value: 'excellent_to_poor'
  },
  {
    name: 'Comment',
    value: 'comment'
  }
]



/** WEBPACK FOOTER **
 ** ./src/forms/options/survey.js
 **/